import { WithAdditionalMarketoFormOverrideProps } from 'marketing-site/src/components/context/MarketoFormOverridePropsContext'
import {
  IOnMarketoFormSubmit,
  IProps as IMarketoFormV2Props,
} from 'marketing-site/src/library/components/MarketoFormV2'
import React, { useEffect } from 'react'
import { IPageBehaviorComponentProps } from './PageBehaviors'

export default function ChiliPiperPB({
  children,
  data,
}: IPageBehaviorComponentProps): React.ReactElement {
  const conf = data.configuration || { chiliPiperId: 'intercom-2' }
  const chiliPiperId = conf.chiliPiperId

  useEffect(() => {
    // TODO: Migrate to next/script when we upgrade to Next 11+
    const script = document.createElement('script')
    // Add script content
    script.src = 'https://js.chilipiper.com/marketing.js'
    script.type = 'text/javascript'

    document.head.appendChild(script)
  }, [])

  const onMarketoFormSubmit: IOnMarketoFormSubmit = (response) => {
    if (response.success) {
      window.ChiliPiper && window.ChiliPiper.submit('intercom', chiliPiperId, { map: true })
    }
  }

  const marketoOverrideProps: Partial<IMarketoFormV2Props> = {
    onSubmit: onMarketoFormSubmit,
    redirectUrl: '',
  }

  return (
    <WithAdditionalMarketoFormOverrideProps overrideProps={marketoOverrideProps}>
      {children}
    </WithAdditionalMarketoFormOverrideProps>
  )
}
